<template lang="pug">
  slider(v-if="!areMeasurementsVisible" :modelValue="zoomLevel" @update:modelValue="update" v-show="!overlay")
  </template>
<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue'
import type { OrbitControls, Camera } from '@rogue/rackbuilder'
import { useRoute } from 'vue-router'
import { Rogue3DEngine } from '../../composables/RogueEngineComposable'
import slider from './slider.vue'
import { useRogue } from '@/js/services/Rogue'
import { useUIStore } from '@/js/stores/uiStore'

const props = defineProps<{engine: Rogue3DEngine, areMeasurementsVisible: boolean}>()

const uiStore = useUIStore()
const rogue = useRogue()
const route = useRoute()

const controls = props.engine.engine?.controlsManager.orbitControls as OrbitControls
const camera = props.engine.engine?.camera as Camera

if (route.query.zoomlens === 'rf1200f8') {
  controls.restrictMovement = false
  controls.enablePan = true
  controls.minDistance = 0
  controls.maxDistance = 100
}

const overlay = computed(() => uiStore.overlay)

const zoomLevel = ref(50)

function updateZoomFromCanvas() {
  const distance = camera.position.distanceTo(controls.target)
  zoomLevel.value = 100 - ((distance - controls.minDistance) / (controls.maxDistance - controls.minDistance)) * 100
}

function update(newVal: number) {
  zoomLevel.value = newVal
  const targetDistance = controls.minDistance + (controls.maxDistance - controls.minDistance) * ((100 - newVal) / 100)
  const direction = new props.engine.module!.Vector3()
  camera.getWorldDirection(direction)
  const currentDistance = camera.position.distanceTo(controls.target)
  const deltaDistance = currentDistance - targetDistance
  camera.position.addScaledVector(direction, deltaDistance)
  controls.update()
}

onMounted(() => {
  controls.addEventListener('change', () => updateZoomFromCanvas())
  updateZoomFromCanvas()
})

</script>
  <style lang="scss" scoped>
  </style>
